import type { FaireProductEntity } from "../../entity_types/product";

export const atc_refined_moma_7: FaireProductEntity = {
  token: "atc_refined_moma_7",
  type: "product",
  name: "Designer Breakfast Set",
  brandName: "Pozzi Milano",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4bdffa881e93d3867f1994832a9c52bfe1a5b66f26f09c299187401b4328252d.webp",
  priceDollars: 48,
  msrpDollars: 76,
  description: "Italian-designed tableware with Memphis-inspired aesthetic.",
  tags: ["tableware", "drinkware", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
